import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  Tooltip,
  Area,
  CartesianGrid,
  Legend,
} from 'recharts';

function StackedAreaChart({ data }) {
  return (
    <div style={{ position: 'relative', marginBottom: '20px' }}>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 20 }}>
          <defs>
            <linearGradient id="incomeGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#28a745" stopOpacity={0.6} />
              <stop offset="95%" stopColor="#28a745" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="expensesGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#dc3545" stopOpacity={0.6} />
              <stop offset="95%" stopColor="#dc3545" stopOpacity={0} />
            </linearGradient>
          </defs>

          <XAxis dataKey="month" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />

          <Area
            type="monotone"
            dataKey="income"
            stroke="rgba(40, 167, 69, 0.8)"
            fillOpacity={1}
            fill="url(#incomeGradient)"
            name="Einnahmen"
          />
          <Area
            type="monotone"
            dataKey="expenses"
            stroke="rgba(220, 53, 69, 0.8)"
            fillOpacity={1}
            fill="url(#expensesGradient)"
            name="Ausgaben"
          />
          <Legend
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{
              position: 'absolute',
              bottom: '-3px',
              left: '50%',
              transform: 'translateX(-50%)',
              fontSize: '13px',
              color: '#aaa',
              fontWeight: '500',
            }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default StackedAreaChart;
